import React from 'react';

import useHeaderFunctions, {
  GoToHomeOptions,
} from 'components/HeadMenu/Header/useHeaderFunctions';
import Logo from 'components/Logo/Logo';

export interface LogoWrapperProps extends GoToHomeOptions {
  height?: string;
}
// All components with useSearchParams should be wrapped in Suspense component
// Here useSearchParams is used in useHeaderFunctions
const LogoLink: React.FC<LogoWrapperProps> = ({
  onHome,
  inviteReferral,
  height,
}) => {
  const { goToHome } = useHeaderFunctions();

  return (
    <Logo
      dataTestId="home"
      height={height}
      href="/"
      onClick={(event: React.MouseEvent): void =>
        goToHome(event, {
          inviteReferral: inviteReferral,
          onHome: onHome,
        })
      }
    />
  );
};

export default LogoLink;
